import { PasswordValidationRequest } from '../api/passwordvalidation/passwordvalidationrequest';
import { PasswordValidationResponse, PasswordValidationResponseDtoImpl } from '../api/passwordvalidation/passwordvalidationresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';

export class PasswordValidationAPIProcessorImpl extends APIProcessorImpl<PasswordValidationRequest, PasswordValidationResponse>
{
    private LOGGER: Logger = LogManager.getLogger(PasswordValidationAPIProcessorImpl.name);
    private msisdn: string;

     execute(request: PasswordValidationRequest): void
    {
        this.msisdn = request.getPasswordValidationRequest().getMsisdn();
        super.execute(request);
    }
      /* execute()
     {
         console.log("execute() in PasswordValidationAPIProcessorImpl"); 

         let passwordValidationResponse = new PasswordValidationResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION, "Valid Password");
        
         let responseMapDto = new ResponseMapDtoImpl();
         responseMapDto.setAccessToken("1e3a077e-445a-40ac-baf3-f8ee50767bc4");
         responseMapDto.setRefreshToken("b74628e1-8457-4f2c-9d92-1bed00bbfcd2");
         responseMapDto.setDeviceId("1");
         responseMapDto.setExpiry(800000);
         passwordValidationResponse.setMessage("Success");
         passwordValidationResponse.setRespTime("Apr 8, 2020 12:15:07 PM");
         passwordValidationResponse.setStatusCode("SC0000");
         passwordValidationResponse.setResponseMap(responseMapDto);
         passwordValidationResponse.setSettings("\"settings\":{}");
             
         this.getAPISuccess(passwordValidationResponse);
     }  */
    /*  "accessToken": "1e3a077e-445a-40ac-baf3-f8ee50767bc4",
    "refreshToken": "b74628e1-8457-4f2c-9d92-1bed00bbfcd2",
     "msisdn": "0504843969",
     "deviceId": "67c49626-558d-486a-abbb-5e035ae41b8e",
     "expiry": 600000, */
     onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            this.LOGGER.log("onSuccess() invoked : "+responseMapper.getStatusCode());
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new PasswordValidationResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION , "Valid Password");

                let responseMap = responseMapper.getResponseMap();
                let getUserContext = this.getContext().getUserContext();
                let context = this.getContext();

                getUserContext.setAccessToken(responseMap.accessToken);
                getUserContext.setRefreshToken(responseMap.refreshToken);
                getUserContext.setChannelId(context.getUserContext().getChannelId());
                getUserContext.setMsisdn(this.msisdn);
                getUserContext.setUserName(this.msisdn);
                getUserContext.setDeviceId(responseMap.deviceId);
                getUserContext.setExpiry((responseMap.expiry - context.getProperty().getRefreshTokenDelta()
                                       ) + Date.now());
                getUserContext.setExpiryTimeStamp(this.getContext().getProperty().getSessionTimeout() + 
                Date.now());
                getUserContext.setIsLoggedIn(true);

                // context.setConfigurationSettings(JSON.parse(JSON.stringify(responseMap.settings)).others);
                context.setUserContext(getUserContext);
                
                this.LOGGER.log("Access Token : "+getUserContext.getAccessToken());
                this.LOGGER.log("Refresh Token : "+getUserContext.getRefreshToken());
                this.LOGGER.log("Msisdn : "+getUserContext.getMsisdn());
                this.LOGGER.log("DeviceId : "+getUserContext.getDeviceId());
                this.LOGGER.log("Expiry : "+getUserContext.getExpiry());
                this.LOGGER.log("Is Login : "+getUserContext.getIsLoggedIn());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new PasswordValidationResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new PasswordValidationResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new PasswordValidationResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
                this.getAPIFailure(new PasswordValidationResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION, responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/passwordvalidationapiprocessor.tsx